import type { StoreApi } from 'zustand';
import { createStore } from 'zustand';
import { devtools } from 'zustand/middleware';

import type { MediaLightboxState } from './MediaLightboxStore.types';

export const createMediaLightboxStore = (instanceId?: string): StoreApi<MediaLightboxState> =>
  createStore<MediaLightboxState>()(
    devtools(
      (set) => ({
        instance: undefined,

        show: (currentItem, messageId) => {
          set({ instance: { currentItem, messageId } });
        },

        hide: () => {
          set({ instance: undefined });
        },
      }),
      { name: instanceId == null ? 'MediaLightboxStore' : `MediaLightboxStore-${instanceId}` }
    )
  );

export type MediaLightboxStore = ReturnType<typeof createMediaLightboxStore>;
